//Formik
import { useField } from "formik"

//PrimeReact
import { Skeleton } from "primereact/skeleton"
import { Editor } from "primereact/editor"

//Style
import styles from "../../styles/Form-Inputs.module.css"

export default function FormikRichTextInput({
  name,
  label,
  required,
  isInitialLoad,
  disabled,
  helpText,
  inputStyles,
}) {
  const [field, meta, helper] = useField(name)

  const inputField = () => {
    if (isInitialLoad) {
      return (
        <Skeleton
          className={meta.touched && meta.error ? "p-invalid block" : "block"}
          height="42px"
        />
      )
    } else {
      let style = { width: "100%" }

      if (!!inputStyles) {
        style = { ...style, ...inputStyles }
      }

      return (
        <Editor
          name={name}
          value={field.value}
          onTextChange={(e) => helper.setValue(e.htmlValue)}
          required={required}
          disabled={disabled}
          className={meta.touched && meta.error ? "p-invalid block" : "block"}
          style={style}
        />
      )
    }
  }

  const labelField = () => {
    if (isInitialLoad) {
      return <Skeleton width="10rem" height="1rem" />
    } else {
      return (
        <label>
          {label} {required ? <span style={{ color: "red" }}> * </span> : null}
        </label>
      )
    }
  }

  return (
    <div className={styles.field}>
      {labelField()}
      <div className="col-12 md:col-10">
        {helpText ? (
          <div style={{ marginBottom: "10px" }}>
            <small style={{ color: "gray" }}>{helpText}</small>
          </div>
        ) : null}
        {inputField()}
        {meta.touched && meta.error ? (
          <label id={`${name}-error`} className={styles.errFieldMsg}>
            {meta.error}
          </label>
        ) : null}
      </div>
    </div>
  )
}
